import { useCallback, useState, useEffect } from "react";

import innerMeta from "../meta.json";

const currentVersion = innerMeta.buildVersion;

let canceled = false;
const defaultProps = {
	autoReload: false,
};

type OwnProps = typeof defaultProps;

/**
 * Clears cache after build if necessary.
 */
export const useClearCache = (props?: OwnProps) => {
	const { autoReload } = {
		...defaultProps,
		...props,
	};

	const [loading, setLoading] = useState(true);
	const [isLatestVersion, setIsLatestVersion] = useState(true);

	useEffect(() => () => {
		canceled = true;
	});

	const clearCache = async (): Promise<void> => {
		if ("caches" in window) {
			caches.keys().then(names => {
				for (const name of names) caches.delete(name);
			});
		}

		window.location.reload();
	};

	const fetchMeta = useCallback(async ({ autoReload = false }) => {
		try {
			//Loads actual build version from server
			await fetch("/meta.json", {
				cache: "no-store",
			})
				.then(response => response.json())
				.then(meta => {
					if (canceled) return;
					let latestVersion = meta.buildVersion;
					const isUpdated = latestVersion === currentVersion;

					if (!isUpdated && !autoReload && !canceled) {
						setLoading(false);
						if (currentVersion) {
							setIsLatestVersion(false);
						}
					} else if (!isUpdated && autoReload) {
						clearCache();
					} else if (!canceled) {
						setIsLatestVersion(true);
						setLoading(false);
					}
				});
		} catch (err) {
			console.error(err);
		}
	}, []);

	useEffect(() => {
		fetchMeta({ autoReload });
	}, [fetchMeta, autoReload]);

	return {
		loading,
		isLatestVersion,
		clearCache,
		checkUpdates: fetchMeta,
	};
};
